import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users', {
        url: '/saaspass-users',
        redirectTo: 'company.user-directories.saaspass-users.all-users',
        component: 'companyUserDirectoriesSaaspassUsers',
        resolve: {
            allRegularCompanyUsers,
            blockedUsers,
            regularUsers,
			labels
        },
    });
}

/** @ngInject */
function allRegularCompanyUsers(companyId, UsersResource) {
    return UsersResource.getAllRegularCompanyUsers(companyId, 'regular');
}

/** @ngInject */
function blockedUsers(allRegularCompanyUsers) {
    return allRegularCompanyUsers.filter((user) => user.blocked !== 'NONE');
}

/** @ngInject */
function regularUsers(allRegularCompanyUsers) {
    return allRegularCompanyUsers.filter((user) => user.blocked === 'NONE');
}
/** @ngInject */
function labels(companyId,UserLabelsService){
	return UserLabelsService.getLabels({companyId}).$promise;
}


// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/saaspass-users.state.js